"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChronosEventBus2 = void 0;
var _message = require("../message/message");
var _address = require("./address");
var _messageRegistery = require("../message/messageRegistery");
var _eventbusBridgeClient = _interopRequireDefault(require("@vertx/eventbus-bridge-client.js"));
var _globalStates = require("../globalstates/globalStates");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EVENTBUS_SETTINGS = {
  vertxbus_reconnect_delay_min: 1000,
  vertxbus_reconnect_delay_max: 5000,
  vertxbus_reconnect_exponent: 2,
  vertxbus_reconnect_attempts_max: 10,
  vertxbus_randomization_factor: 0.5,
  vertxbus_ping_interval: 2000
};
var DISABLE_LOGGING = [{
  catagory: 1800,
  type: 0
}, {
  catagory: 3009,
  type: 17
}];
var showLog = function showLog(msg) {
  return DISABLE_LOGGING.findIndex(function (d) {
    return d.catagory === msg.msgCategory && d.type === msg.msgType;
  }) < 0;
};
var ChronosEventBus2 = exports.ChronosEventBus2 = /*#__PURE__*/_createClass(function ChronosEventBus2(systemID, userID, userSessionID, connectionID) {
  var _this = this;
  _classCallCheck(this, ChronosEventBus2);
  _defineProperty(this, "msgDecoder", new _message.MsgDecoder());
  _defineProperty(this, "connectPromise", null);
  _defineProperty(this, "rebooting", false);
  _defineProperty(this, "connected", false);
  _defineProperty(this, "openCallback", function () {
    if (_this.onOpen) {
      _this.onOpen();
    }
  });
  _defineProperty(this, "closeCallback", function (e) {
    if (_this.onClose) {
      _this.onClose(e);
    }
  });
  _defineProperty(this, "hasMatchingSession", function (userData) {
    if (userData === null) {
      return false;
    }
    if (userData.userID === null || userData.userID.value !== _this.userID || userData.userSessionID === null || userData.userSessionID !== _this.userSessionID || userData.connectionID === null || userData.connectionID !== _this.connectionID) {
      return false;
    }
    return true;
  });
  _defineProperty(this, "setRebooting", function () {
    _this.rebooting = true;
  });
  _defineProperty(this, "get", function (url) {
    if (!(0, _globalStates.getGlobalStates)().isReady) {
      _this.connectPromise = null;
      console.debug("Please initGlobalStates first");
      return Promise.reject(_this);
    }
    if (_this.eb) {
      _this.connectPromise = null;
      return Promise.resolve(_this);
    }
    if (_this.connectPromise) {
      return _this.connectPromise;
    }
    _this.connectPromise = new Promise(function (resolve, reject) {
      var failed = function failed(e, type) {
        console.error("Eventbus connection " + type, e);
        _this.eb = undefined;
        _this.connectPromise = null;
        _this.closeCallback(e);
        reject(_this);
      };
      var success = function success() {
        console.debug("Eventbus connected");
        _this.connectPromise = null;
        _this.openCallback();
        resolve(_this);
      };
      var openEventBus = function openEventBus() {
        if (_this.userID && _this.userSessionID && _this.connectionID) {
          _this.addressing = new _address.EventBusAddress(_this.systemID);
          var eventBusUrl = "".concat((0, _globalStates.getGlobalStates)().host).concat(_address.EVENTBUS_PATH) + "?userId=" + "".concat(_this.userID) + "&connectionId=" + "".concat(_this.connectionID);
          _this.eb = new _eventbusBridgeClient["default"](eventBusUrl, EVENTBUS_SETTINGS);
          _this.eb.onerror = function (e) {
            _this.connected = false;
            if (e.type == "err" && e.body == "access_denied") {
              console.error("Access denied", e);
              //TODO: Please implement an access denied popup window for the user
              //TODO: to avoid infinite loading screen as well as for better user experience
            } else {
              // close and retry
              console.error("Unexpected error. Close connection and retry", e);
              failed(e, "error");
            }
          };
          _this.eb.onopen = function () {
            _this.rebooting = false;
            if (_this.connectPromise != null) {
              success();
            }
            _this.eb.registerHandler(_this.addressing.getReceiveAddress((0, _globalStates.getGlobalStates)().sessionID), function (err, msg) {
              if (_this.connected) {
                try {
                  var messageObject = JSON.parse(msg.body);
                  var decodedMsg = _this.msgDecoder.decodeMsg(messageObject);
                  if (decodedMsg) {
                    var category = "".concat(decodedMsg.msgCategory);
                    var type = "".concat(decodedMsg.msgType);
                    if (showLog(decodedMsg)) {
                      try {
                        console.debug("Received msg ".concat(category, "/").concat(type, ": ").concat(JSON.stringify(JSON.parse(decodedMsg.payload))));
                      } catch (err) {
                        console.debug("Received msg  ".concat(category, "/").concat(type, ": ").concat(decodedMsg.payload));
                      }
                    }
                    (0, _messageRegistery.handleMsg)(decodedMsg);
                  }
                } catch (e) {
                  console.error("Cannot decode received msg", e);
                }
              }
            });
          };
          _this.eb.onclose = function (e) {
            console.debug("Eventbus onclose");
            console.error(e);
            failed(e, "closed");
          };
        } else {
          // TODO: Handle error. Keycloak User ID and User Session ID required to open the eventbus
          failed("Keycloak User ID and User Session ID required to open the eventbus", "error");
        }
      };
      openEventBus();
    });
    return _this.connectPromise;
  });
  _defineProperty(this, "sendMsg", function (msgDef, msg) {
    if (!_this.eb) {
      console.error("Cannot send msg due to event bus is closed");
      return;
    }
    var userData = (0, _globalStates.getGlobalStates)().userData;
    if (!(0, _globalStates.isUserAuthorized)() || !_this.hasMatchingSession(userData)) {
      if ((0, _globalStates.getGlobalStates)().keycloak && (0, _globalStates.getGlobalStates)().keycloak.authenticated) {
        console.warn("Authorization missing. Re-authorizing user = '" + userData.userName + "', appId: " + (0, _globalStates.getGlobalStates)().appID.value);
      }
      window.location.replace((0, _globalStates.getGlobalStates)().host);
    } else {
      var encodedMsgs = (0, _message.encodeMsg)(msgDef, msg);
      encodedMsgs.forEach(function (encodedMsg) {
        _this.eb.send(_this.addressing.getSendAddress(), (0, _globalStates.getGlobalStates)().sessionID.prefixMsg(encodedMsg));
      });
    }
  });
  this.systemID = systemID;
  this.userID = userID;
  this.userSessionID = userSessionID;
  this.connectionID = connectionID;
});